import { Shape, SpotShape, SpotShapeItem } from '../types';

export const getSpotsWithoutResourceId = (shapes: Shape[]): SpotShapeItem[] => {
  return shapes.flatMap((shape) => {
    if (shape.type === 'spot' && !shape.resource_id) {
      return shape;
    }
    if (shape.type === 'group' && Array.isArray(shape.children)) {
      return getSpotsWithoutResourceId(shape.children);
    }
    return [];
  });
};

export const getSpotsWithResourceId = (shapes: Shape[]): SpotShapeItem[] => {
  return shapes.flatMap((shape) => {
    if (shape.type === 'spot' && shape.resource_id) {
      return shape;
    }
    if (shape.type === 'group' && Array.isArray(shape.children)) {
      return getSpotsWithResourceId(shape.children);
    }
    return [];
  });
};

export const getSpotNameFromSpotShapeItem = (spotItem: SpotShape) => {
  return spotItem.label;
};

export const assignResourceIdToSpotId = (
  shapes: Shape[],
  spotId: string,
  resource_id: string
): Shape[] => {
  return shapes.map((shape) => {
    if (shape.type === 'spot' && shape.id === spotId) {
      return { ...shape, resource_id };
    }

    if (shape.type === 'group' && Array.isArray(shape.children)) {
      return {
        ...shape,
        children: assignResourceIdToSpotId(shape.children, spotId, resource_id)
      };
    }

    return shape;
  });
};

export const assignLabelToSpotWithResourceId = (
  shapes: Shape[],
  resource_id: string,
  label: string
): Shape[] => {
  return shapes.map((shape) => {
    if (shape.type === 'spot' && shape.resource_id === resource_id) {
      return { ...shape, label };
    }

    if (shape.type === 'group' && Array.isArray(shape.children)) {
      return {
        ...shape,
        children: assignLabelToSpotWithResourceId(
          shape.children,
          resource_id,
          label
        )
      };
    }

    return shape;
  });
};

export const assignNameToSpotWithResourceId = (
  shapes: Shape[],
  resource_id: string,
  name: string
): Shape[] => {
  return shapes.map((shape) => {
    if (shape.type === 'spot' && shape.resource_id === resource_id) {
      return { ...shape, name };
    }

    if (shape.type === 'group' && Array.isArray(shape.children)) {
      return {
        ...shape,
        children: assignLabelToSpotWithResourceId(
          shape.children,
          resource_id,
          name
        )
      };
    }

    return shape;
  });
};

export const getDeletedSpotsWithResources = (
  originalShapes: SpotShape[],
  newShapes: Shape[]
): SpotShape[] => {
  const originalSpots = getSpotsWithResourceId(originalShapes);
  const newSpots = getSpotsWithResourceId(newShapes);

  return originalSpots.filter((originalSpot) => {
    return !newSpots.find((newSpot) => newSpot.id === originalSpot.id);
  }) as SpotShape[];
};
